import React, { Fragment, useState } from "react";
import { Button, Col, Form, Row, Input } from "antd";
import { FormattedMessage } from "react-intl";
import { Image } from "@models/image";
import ImagePickerModal from "@components/custom/imagePicker/Modal";

interface SliderProps {
  selectedImage: Image | null;
  form?: any;
  label?: string;
  field?: string;
  required?: boolean;
}

const WidgetItemImageSelection: React.FC<SliderProps> = props => {
  const { form, selectedImage, label = 'app.select_image', field = 'image_file', required = true } = props;
  const [image, setImage] = useState(selectedImage || null);

  const onSelectImage = (image: Image) => {
    setImage(image);
    form.setFieldsValue({
      [field]: image
    });
  };

  return (
    <Fragment>
      <Form.Item className={"no-label"}>
        {form.getFieldDecorator(field, {
          initialValue: image
        })(<Input type={`hidden`} />)}
      </Form.Item>
      <Row gutter={24} className={`video-poster-wrapper`}>
        <Col span={24}>
          <Form.Item className={"no-label"}>
            {form.getFieldDecorator(field.replace('file', 'id'), {
              initialValue: image ? image.id : null,
              rules: [
                {
                  required: required && !image,
                  message: (
                    <FormattedMessage
                      id="app.image_is_required"
                      defaultMessage={`image is required!`}
                    />
                  )
                }
              ]
            })(
              <ImagePickerModal
                onSelectImage={onSelectImage}
                selectedImage={image}
              >
                <div
                  className={`image-wrapper`}
                  style={{ backgroundImage: `url(${image ? image.path : ""})` }}
                >
                  <FormattedMessage
                    id={label}
                    defaultMessage={`Select image`}
                  />
                </div>
              </ImagePickerModal>
            )}
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  );
};

export default WidgetItemImageSelection;
